import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))
function AI_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <AI_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <AI_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function AI_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  return (
    <>
      <div className={classes.root}>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What educational background do I need to pursue a career in AI?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              A career in AI typically requires a strong foundation in
              mathematics, statistics, and computer science. Most professionals
              in the field have at least a bachelor's degree in computer
              science, data science, or a related field. Advanced positions may
              require a master's or Ph.D. in AI, machine learning, or a similar
              discipline.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What programming languages should I learn for a career in AI?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Common programming languages in AI include Python (widely used for
              its libraries like TensorFlow and PyTorch), R (especially for
              statistical analysis), Java, C++, and Julia. Familiarity with
              these languages will be beneficial for implementing algorithms and
              developing AI models.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What skills are essential for a career in AI?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Key skills include:
              <ul>
                <li>Proficiency in programming and software development.</li>
                <li>
                  Understanding of machine learning algorithms and frameworks.
                </li>
                <li>
                  Strong mathematical skills, particularly in linear algebra,
                  calculus, and probability.
                </li>
                <li>Data analysis and visualization skills.</li>
                <li>
                  Familiarity with cloud computing and big data technologies.
                </li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What types of roles are available in the AI field?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              There are various roles in AI, including:
              <ul>
                <li>Machine Learning Engineer</li>
                <li>Data Scientist, AI Product Manager</li>
                <li>AI Research Scientist</li>
                <li>
                  Computer Vision Engineer, Natural Language Processing Engineer
                </li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What are the potential career paths and growth opportunities in
              AI?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              AI offers numerous career growth opportunities, including moving
              into leadership roles such as AI team lead or chief data officer.
              Professionals can also specialize further in specific areas of AI,
              like deep learning or robotics, or transition into related fields
              such as data analytics, business intelligence, or software
              engineering.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  )
}
export default AI_FAQ_page
